import { Injectable } from "@angular/core";
import { v4 as uuid } from "uuid";

@Injectable({
	providedIn: "root"
})
export class TabTrap {
	lastFocus: any = null;
	tabbableSelector = `a[href], area[href], input:not([disabled]):not([tabindex='-1']),
	button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
	textarea:not([disabled]):not([tabindex='-1']),
	iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]`;
	active;

	$_TabTrap_detectEsc(e) {
		const key = e.key.toLowerCase();
		if (key.indexOf("esc") !== -1) {
			this.active = false;
		}
	}
	$_TabTrap_getFocusableElements(container) {
		return container.querySelectorAll(
			"button, [role=button], [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
		);
	}
	$_TabTrap_nextFocusableElement(container, backward) {
		const focusable = this.$_TabTrap_getFocusableElements(container);
		const first = focusable[0];
		const last = focusable[focusable.length - 1];
		if (
			backward &&
			(document.activeElement === first || container === this.lastFocus)
		) {
			return last;
		}
		if (!backward && document.activeElement === last) {
			return first;
		}
	}
	$_TabTrap_trap(e, container) {
		const key = e.key.toLowerCase();
		if (
			key.indexOf("tab") !== -1 ||
			key.indexOf("down") !== -1 ||
			key.indexOf("up") !== -1 ||
			key.indexOf("right") !== -1 ||
			key.indexOf("left") !== -1
		) {
			const backward = e.shiftKey;
			const nextFocus = this.$_TabTrap_nextFocusableElement(
				container,
				backward
			);
			if (nextFocus) {
				e.preventDefault();
				nextFocus.focus();
			}
		}
	}
	$_TabTrap_focusTrap(e, container) {
		if (typeof container !== "undefined" && !container.contains(e.target)) {
			e.stopPropagation();
			if (container === this.lastFocus) {
				let toFocus = this.$_TabTrap_nextFocusableElement(
					container,
					true
				);
				toFocus.focus();
			} else {
				container.focus();
			}
		}
		this.lastFocus = document.activeElement;
	}
	$_TabTrap_blurTrap(e, container) {
		this.lastFocus = e.target;
		if (
			typeof container !== "undefined" &&
			!container.contains(e.relatedTarget) &&
			container !== e.relatedTarget &&
			e.relatedTarget != null
		) {
			e.preventDefault();
			e.stopPropagation();
			if (container === e.target) {
				let toFocus = this.$_TabTrap_nextFocusableElement(
					container,
					true
				);
				toFocus.focus();
			} else {
				container.focus();
			}
		} else if (typeof e.relatedTarget === "undefined") {
			e.preventDefault();
			e.stopPropagation();
			container.focus();
		}
	} // Import from RIG
	$_TabTrap_focusGroup(element) {
		let elements = element.querySelectorAll(this.tabbableSelector);
		return elements
			? Array.prototype.filter.call(elements, el =>
				this.$_TabTrap_isVisible(el)
			)
			: elements;
	}

	$_TabTrap_isFocusInFirstItem(event, list) {
		if (list.length > 0) {
			return (event.target || event.srcElement) === list[0];
		}
		return false;
	}

	$_TabTrap_isFocusInLastItem(event, list) {
		if (list.length > 0) {
			return (event.target || event.srcElement) === list[list.length - 1];
		}
		return false;
	}

	$_TabTrap_isElementFocused(event, element) {
		return (event.target || event.srcElement) === element;
	}

	$_TabTrap_focusFirstFocusableElement(list) {
		if (list.length > 0) {
			list[0].focus();
			return true;
		}
		return false;
	}

	$_TabTrap_focusLastFocusableElement(list) {
		if (list.length > 0) {
			list[list.length - 1].focus();
			return true;
		}
		return false;
	}

	$_TabTrap_isVisible(element) {
		return !!(
			element.offsetWidth ||
			element.offsetHeight ||
			element.getClientRects().length
		);
	}

	$_TabTrap_lockFocus(event, element) {
		if (event.key === "Tab") {
			let list = this.$_TabTrap_focusGroup(element);
			let focusChanged = false;
			if (event.shiftKey) {
				if ( this.$_TabTrap_isFocusInFirstItem(event, list) || this.$_TabTrap_isElementFocused(event, element)) {
					focusChanged = this.$_TabTrap_focusLastFocusableElement(list);
				}
			} else {
				if (this.$_TabTrap_isFocusInLastItem(event, list)) {
					element.focus();
					focusChanged = true;
				}
			}

			if (focusChanged) {
				event.preventDefault();
				event.stopPropagation();
			}
		}
	}
}
